import { Box, Button, Typography } from "@mui/material";
import styles from "../../styles/components/messageBoxEven.module.scss";
import React from "react";

import assest from "../../json/assest";
import DownloadIcon from "../../ui/Icons/DownloadIcon";
import {
    concatHostAndImagePath,
    getAbsoluteDownloadURI,
    getAbsoluteImageURI,
} from "../../lib/functions/utils.lib";
import { getCookie } from "../../lib/functions/storage.lib";
import NOprofileImage from "../../public/assets/images/no-image.svg";

const MessageBoxEven = (props) => {
    const userCookie = getCookie("userdetails");
    const user = JSON.parse(userCookie ? userCookie : "{}");

    const handleDownload = (fileLink) => {
        window.open(getAbsoluteDownloadURI(fileLink), "_blank");
    };
    return (
        <Box
            className={`messageModal messagemodalEven ${
                props.pfName === `${user.name} ${user.last_name}`
                    ? styles.messageSender
                    : ""
            }`}
        >
            <Box className="messageModalHeader">
                <Box className="messageMOdalProfile">
                    <Box className="messageMOdalProfileImg">
                        {/* <img src={props?.pfAvatar} width={39} height={39} alt='' /> */}
                        <img
                            src={
                                props?.pfAvatar === "users/default.png"
                                    ? NOprofileImage
                                    : concatHostAndImagePath(props?.pfAvatar)
                                // : assest.noUser
                            }
                            width={39}
                            height={39}
                            alt=""
                        />
                    </Box>
                    <h4>
                        {props?.pfName}
                        <span>({props?.designation})</span>
                    </h4>
                </Box>
                <p>{props?.postedDate}</p>
            </Box>
            <Box className="messageModalBodyTxt">{props?.msgContent}</Box>
            {props.attachFile?.length ? (
                <>
                    <Box className={styles.cardAttach}>
                        <Typography variant="caption">
                            Attached files:
                        </Typography>
                        {props.attachFile?.map((item, index) => {
                            return (
                                <Button
                                    key={index}
                                    startIcon={<DownloadIcon />}
                                    onClick={() => handleDownload(item?.file)}
                                >
                                    {item?.name}
                                </Button>
                            );
                        })}
                    </Box>
                </>
            ) : null}
        </Box>
    );
};

export default MessageBoxEven;
